import env from "../../utils/env";
import common from "../../utils/common";
 
let AffiliatesService = function (HttpService) {
  "ngInject";
 
  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("affiliates/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        create: {
          url: env.getApiUrl("affiliates/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { type: "date", editable: false, validation: { required: true } },
            "code": { nullable: false, validation: { required: true } },
            "startDate": { type: "date", nullable: false, validation: { required: true } },
            "expireDate": { type: "date", nullable: false, validation: { required: true } },
            "affiliateName": { nullable: false, validation: { required: true } },
            "affilateType": { defaultValue: 0 },
            "creditAmount": { defaultValue: 0 },
            "activationsCount": { defaultValue: 0 },
            "activationsLimit": { defaultValue: 0 },
            "paymentType": { defaultValue: 0 },
            "emailPattern": {},
            "id": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })
 
    return dataSource;
  }
 
  const getAffiliateUsersDataSource = (id, successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("affiliates/affiliateusers/" + id),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })
 
    return dataSource;
  }
 
  const getAffiliateJobsDataSource = (id, successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("affiliates/affiliatejobs/" + id),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })
 
    return dataSource;
  }
 
  return { getDataSource, getAffiliateUsersDataSource, getAffiliateJobsDataSource };
}
 
function _getResourceLocation(options) {
  return env.getApiUrl(`affiliates/${options.id}`);
}
 
function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;
 
  req.setRequestHeader("Authorization", token);
}
 
function _parameterMap(data, type) {
  if (type == "read") {
    let filters = [];
 
    if (data.filter) filters = data.filter.filters;
 
    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;
 
    console.log("Query::", query)
 
    return JSON.stringify(query);
  }
 
  if (type == "create") {
 
    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.
 
    delete data.id;
    data.expireDate = common.converToUtcDate(data.expireDate);
    data.startDate = common.converToUtcDate(data.startDate);
 
    if (data.affiliateType && data.affiliateType.value) {
      data.affiliateType = data.affiliateType.value;
    }
 
    if (data.paymentType && data.paymentType.value) {
      data.paymentType = data.paymentType.value;
    }
 
    if (data.secondaryPaymentType && typeof data.secondaryPaymentType === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
      data.secondaryPaymentType = data.secondaryPaymentType.value;
    }
 
    console.log("Data::", data);
 
    return JSON.stringify(data);
  }
 
  if (type == "update") {
 
    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.
 
    data.expireDate = common.converToUtcDate(data.expireDate);
    data.startDate = common.converToUtcDate(data.startDate);
 
    if (data.affiliateType && data.affiliateType.value) {
      data.affiliateType = data.affiliateType.value;
    }
 
    if (data.secondaryPaymentType && typeof data.secondaryPaymentType === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
      data.secondaryPaymentType = data.secondaryPaymentType.value;
    }
 
    console.log("Data::", data);
 
    return JSON.stringify(data);
  }
}
 
export default AffiliatesService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/affiliates.service.js
 **/